import { FaMoneyBillWave, FaWallet, FaBalanceScale, FaExchangeAlt, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { store } from '../../Store/store';
import { currencySymbols } from '../../Common/CommonVariables';
import React, { useState, useRef, useEffect } from "react";
import * as bootstrap from "bootstrap";

const TransactionCard = ({ data }) => {

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((el) => {
      new bootstrap.Tooltip(el, { html: true });
    });
  }, []);


  const now = new Date(); // let's say it's May 2025
  const formatMonthYear = (date) =>
    date.toLocaleString('default', { month: 'short' }) + '-' + String(date.getFullYear()).slice(-2);

  const currentMonthLabel = formatMonthYear(now);
  const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const previousMonthLabel = formatMonthYear(prevMonth);

  //console.log(currentMonthLabel);  // "May-25"
  //console.log(previousMonthLabel); // "Apr-25"

  const navigate = useNavigate();

  const userInfo = store.getState();

  return (
    // <div className="bg-white rounded p-3 shadow-sm h-100 d-flex flex-column">
    <>
      {/* Header */}


      {/* Stat Boxes */}
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-1 row-cols-xl-2 g-2 justify-content-center align-items-stretch mb-2">

        {/* Closing Balance */}
        <div className="col">
          <div className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75px' }}>
            <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
              <FaBalanceScale className="text-warning me-1" />
              {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{data.closingBalance || 0}
            </div>
            <div className="d-flex align-items-end justify-content-center gap-1">
              {/* <small className="text-dark">Closing Balance</small>
              <small className="text-dark" style={{ fontSize: '0.6rem' }}>({previousMonthLabel})</small> */}
              <small className="text-dark">Opening Balance</small>
            </div>
            {/* <small className="text-dark" style={{ fontSize: '0.6rem' }}>
              ({previousMonthLabel})
            </small> */}
          </div>
        </div>

        {/* Deposit */}
        <div className="col">
          <div className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75px' }}>
            <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
              <FaMoneyBillWave className="text-success me-1" />
              {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{data.totalDeposit || 0}
            </div>
            <small className="text-dark">Deposits</small>
          </div>
        </div>

        {/* Current Balance */}
        <div className="col">
          <div className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75px' }}>
            <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
              <FaWallet className="text-info me-1" />
              {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{data.currentBalance || 0}
            </div>
            <div className="d-flex align-items-end justify-content-center gap-1">
              <small className="text-dark">Current Balance</small>
              {/* <small className="text-dark" style={{ fontSize: '0.5rem' }}>({currentMonthLabel})</small> */}
            </div>
          </div>
        </div>

        {/* Transactions */}
        {/* <div className="col">
          <div className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75px' }}>
            <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
              <FaExchangeAlt className="text-danger me-1" />
              {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{data.totalTransaction || 0} |&nbsp;
               {data.totalTransactionEntries || 0} |
               {data.entries || 0} | 
               {data.refundEntries || 0}
            </div>
            <small className="text-dark">Transactions</small>
          </div>
        </div> */}
        <div className="col position-relative">
          <div
            className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center"
            style={{ minHeight: "75px" }}
          >
            <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold position-relative">
              <FaExchangeAlt className="text-danger me-1" />
              {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
              {data.totalTransaction || 0} |&nbsp;
              {data.totalTransactionEntries || 0}
              {/* | {data.entries || 0} | {data.refundEntries || 0} */}

              {/* {data.totalTransactionEntries > 0 && (
                <i
                  className="fas fa-info-circle text-muted"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-html="true"
                  data-bs-custom-class="custom-tooltip"
                  title={[
                    data.entries > 0 ? `Transactions: ${data.entries}` : '',
                    data.refundEntries > 0 ? `Refund: ${data.refundEntries}` : ''
                  ]
                    .filter(Boolean)
                    .join('<br>')}
                  style={{
                    fontSize: "12px",
                    position: "absolute",
                    top: "-5px",
                    right: "-12px",
                    cursor: "pointer"
                  }}
                ></i>

              )} */}
            </div>
            <small className="text-dark">Transactions</small>
          </div>
        </div>

      </div>


      <div className="text-end mt-2">
        <a
          href="/transactions"
          className="fw-bold small "
          style={{ color: "#00984A", fontSize: "12px" }}
        >
          View All Transactions <FaArrowRight className="ms-1" style={{ fontSize: "12px" }} />
        </a>
      </div>

      {/* <div className="text-center mt-auto mb-2" style={{float:"right"}}>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => navigate('/transactions')}
        >
          View All Transactions
        </button>
      </div> */}
    </>

  );
};

export default TransactionCard;
